module.exports = __webpack_public_path__ + "img/Logo_teal_stacked_0.25x-removebg-preview.bab71703.png";